<template>
  <div class="contact-form has-background-white">
    <div class="header m-b-lg">
      <h3 class="has-text-weight-bold is-size-4">Escríbenos</h3>
      <p class="has-text-weight-medium is-size-5">
        con gusto te atenderemos
      </p>
    </div>
    <div class="field is-horizontal">
      <div class="field-body">
        <b-field
          label="Nombre*"
          label-for="name"
          custom-class="has-text-weight-medium"
        >
          <b-input v-model="name" id="name"></b-input>
        </b-field>
        <b-field
          label="Correo electrónico*"
          label-for="email"
          custom-class="has-text-weight-medium"
        >
          <b-input
            v-model="email"
            type="email"
            validation-message="El correo electrónico no es valido"
            id="email"
          ></b-input>
        </b-field>
      </div>
    </div>
    <b-field
      label="Teléfono/Celular*"
      label-for="tel"
      custom-class="has-text-weight-medium"
    >
      <b-input
        type="tel"
        v-model="phone"
        placeholder="(Obligatorio)"
        id="tel"
      />
    </b-field>
    <div class="field is-horizontal">
      <div class="field-body">
        <b-field label="Motivo" custom-class="has-text-weight-medium">
          <div class="block">
            <b-radio v-model="reason" name="name" native-value="Vender">
              Vender
            </b-radio>
            <b-radio
              v-model="reason"
              name="name"
              native-value="Dejar administracion"
            >
              Dejar administración
            </b-radio>
            <b-radio v-model="reason" name="name" native-value="Rentar">
              Rentar
            </b-radio>
            <b-radio v-model="reason" name="name" native-value="Otro">
              Otro
            </b-radio>
          </div>
        </b-field>
      </div>
    </div>
    <b-field
      label="Mensaje"
      label-for="message"
      custom-class="has-text-weight-medium"
    >
      <b-input
        v-model="message"
        type="textarea"
        minlength="10"
        placeholder="¿Cómo podemos ayudarte?"
        id="message"
      >
      </b-input>
    </b-field>
    <b-button
      :disabled="!isValidPhone"
      type="is-primary"
      class="has-text-weight-bold"
      :class="{ 'has-background-success': send }"
      expanded
      @click="dispatchForm"
    >
      {{ messageForm }}
    </b-button>
  </div>
</template>

<script>
import Companies from "@/services/companies";
import { validatePhone } from "@/utils/validate";

export default {
  name: "ContactForm",

  data() {
    return {
      name: "",
      email: "",
      phone: "",
      reason: "",
      message: "",
      send: false
    };
  },

  computed: {
    isValidPhone() {
      return this.phone.length !== 0 && validatePhone(this.phone);
    },
    messageForm() {
      return this.send ? "Enviado" : "Enviar";
    }
  },

  methods: {
    dispatchForm() {
      const data = {
        fullName: this.name,
        email: this.email,
        phone: this.phone,
        motive: this.reason,
        comments: this.message
      };
      Companies.contactMailing(data)
        .then(() => {
          this.send = true;
          setTimeout(() => {
            this.send = false;
          }, 2000);
          this.clearForm();
        })
        .catch(err => {
          console.error(err);
        });
    },
    clearForm() {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.reason = "";
      this.message = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-form {
  padding: 3em;
  border-radius: $radius-large;
}
</style>
